export enum BillingPeriodKey {
  Monthly = 'route.loyalty.premium.subscription_management.per_month_short',
  Annual = 'route.loyalty.premium.subscription_management.per_year_short',
}

export enum BillingPeriodLongKey {
  Monthly = 'route.loyalty.premium.subscription_management.per_month_long',
  Annual = 'route.loyalty.premium.subscription_management.per_year_long',
}
